var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_vm._t("modal-content",[_vm._v("Your modal form here")])],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }